module.exports = __webpack_public_path__ + "img/ennetix-zone-table.44b4538b.png";